<template>
  <form>
    
    <div class="row">
      <div class="col-lg-4">
        <h4 class="card-title">{{$t('medium_grant.technical__2_organisational_info')}}</h4>
        <div class="form-group ">
          <label for="regionSelect">{{$t('medium_grant.technical__2_org_legal_name')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.orgLegalName"
            v-model="GrantForm.revisionModel.technical.orgLegalName"
            :error="getError('technical.orgLegalName')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__2_org_legal_name')"
            :label="$t('medium_grant.technical__2_org_legal_name')"
            :placeholder="$t('medium_grant.technical__2_org_legal_name')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="regionSelect">{{$t('medium_grant.technical__2_org_short_name')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.orgShortName"
            v-model="GrantForm.revisionModel.technical.orgShortName"
            :label="$t('medium_grant.technical__2_org_short_name')"
            :placeholder="$t('medium_grant.technical__2_org_short_name')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="regionSelect">{{$t('medium_grant.technical__2_website')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.website"
            v-model="GrantForm.revisionModel.technical.website"
            :label="$t('medium_grant.technical__2_website')"
            :placeholder="$t('medium_grant.technical__2_website')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="regionSelect">{{$t('medium_grant.technical__2_mailing')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.mailing"
            v-model="GrantForm.revisionModel.technical.mailing"
            :error="getError('technical.mailing')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__2_mailing')"
            :label="$t('medium_grant.technical__2_mailing')"
            :placeholder="$t('medium_grant.technical__2_mailing')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="regionSelect">{{$t('medium_grant.technical__2_physical')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.physical"
            v-model="GrantForm.revisionModel.technical.physical"
            :error="getError('technical.physical')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__2_physical')"
            :label="$t('medium_grant.technical__2_physical')"
            :placeholder="$t('medium_grant.technical__2_physical')"
          >
          </textarea>
        </div>

        <h3 class="card-title">{{$t('medium_grant.technical__2_project_lead_contact_title')}}</h3>
        <p class="small">{{$t('medium_grant.technical__2_project_lead_contact_sub')}}</p>
        <div class="form-group ">
          <label for="regionSelect">{{$t('medium_grant.general__name')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.leadName"
            v-model="GrantForm.revisionModel.technical.leadName"
            :error="getError('technical.leadName')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__name')"
            :label="$t('medium_grant.general__name')"
            :placeholder="$t('medium_grant.general__name')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="regionSelect">{{$t('medium_grant.general__email')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.leadEmail"
            v-model="GrantForm.revisionModel.technical.leadEmail"
            :error="getError('technical.leadEmail')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__email')"
            :label="$t('medium_grant.general__email')"
            :placeholder="$t('medium_grant.general__email')"
          >
          </textarea>
        </div>
        <div class="form-group ">
           <label for="regionSelect">{{$t('medium_grant.general__telephone')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.leadPhone"
            v-model="GrantForm.revisionModel.technical.leadPhone"
            :error="getError('technical.leadPhone')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__telephone')"
            :label="$t('medium_grant.general__telephone')"
            :placeholder="$t('medium_grant.general__telephone')"
          >
          </textarea>
        </div>
        <h3 class="card-title">{{$t('medium_grant.technical__2_org_chief_title')}}</h3>
        <p class="small">{{$t('medium_grant.technical__2_org_chief_sub')}}</p>
        <div class="form-group ">
          <label for="regionSelect">{{$t('medium_grant.general__name')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.chiefName"
            v-model="GrantForm.revisionModel.technical.chiefName"
            :error="getError('technical.chiefName')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__name')"
            :label="$t('medium_grant.general__name')"
            :placeholder="$t('medium_grant.general__name')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="regionSelect">{{$t('medium_grant.general__email')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.chiefEmail"
            v-model="GrantForm.revisionModel.technical.chiefEmail"
            :error="getError('technical.chiefEmail')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__email')"
            :label="$t('medium_grant.general__email')"
            :placeholder="$t('medium_grant.general__email')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="regionSelect">{{$t('medium_grant.general__telephone')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.chiefPhone"
            v-model="GrantForm.revisionModel.technical.chiefPhone"
            :error="getError('technical.chiefPhone')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__telephone')"
            :label="$t('medium_grant.general__telephone')"
            :placeholder="$t('medium_grant.general__telephone')"
          >
          </textarea>
        </div>
        <!--check if IUCN member -->
        <div class="form-group ">
        <p class="small">Is an IUCN member?<i class="hover-instruction"></i></p>
        <div class="form-check form-check-radio form-check-inline">
          <radio name="iucnMember" inline value="true" v-model="GrantForm.revisionModel.technical.iucnMember">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="iucnMember" inline value="false" v-model="GrantForm.revisionModel.technical.iucnMember">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>

                <!-- Other Projects -->
        <h3 class="card-title">{{$t('applications.section_title__other_projects')}}</h3>
        <div class="form-group ">
        <p class="small">{{$t('applications.field_title_in_other_projects_one')}}<i class="hover-instruction"></i></p>
        <div class="form-check form-check-radio form-check-inline">
          <radio name="otherProjectsOne" inline value="true" v-model="GrantForm.revisionModel.technical.otherProjectsOne">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="otherProjectsOne" inline value="false" v-model="GrantForm.revisionModel.technical.otherProjectsOne">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>

        <div>
        <p class="small">{{$t('applications.field_title_in_other_projects_two')}}<i class="hover-instruction"></i></p>
        <div class="form-check form-check-radio form-check-inline form-group ">
          <radio name="otherProjectsTwo" inline value="true" v-model="GrantForm.revisionModel.technical.otherProjectsTwo">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="otherProjectsTwo" inline value="false" v-model="GrantForm.revisionModel.technical.otherProjectsTwo">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>

        <div class="form-group " v-if="GrantForm.revisionModel.technical.otherProjectsTwo == 'true'">
        <label>Please enter the grant Id</label>
        <base-input>
            <textarea
              class="form-control disable-text"
              :placeholder="'Please enter the grant Id'"
              v-model="GrantForm.revisionModel.technical.otherGrantId"
            >
            </textarea>
        </base-input>   
        </div>

        <div>
        <p class="small">{{$t('applications.field_title_in_other_projects_three')}}<i class="hover-instruction"></i></p>
        <div class="form-check form-check-radio form-check-inline form-group ">
          <radio name="otherProjectsThree" inline value="true" v-model="GrantForm.revisionModel.technical.otherProjectsThree">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="otherProjectsThree" inline value="false" v-model="GrantForm.revisionModel.technical.otherProjectsThree">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>
        <div class="form-group " v-if="GrantForm.revisionModel.technical.otherProjectsThree == 'true'">
        <label>Please enter the name of the grant-mechanism</label>
        <base-input>
            <textarea
              class="form-control disable-text"
              :placeholder="'Please enter the name of the grant-mechanism'"
              v-model="GrantForm.revisionModel.technical.grantMechanism"
              :label="'Please enter the name of the grant-mechanism'"
            >
            </textarea>
        </base-input>   
        </div>
        <!--other projects end-->
      </div>
      <div class="col-lg-1"></div>
      <div class="col-lg-7">
        <h3 class="card-title">{{$t('medium_grant.technical__2_org_type_aplicant')}}</h3>
        <p class="small">{{$t('medium_grant.technical__2_org_type_aplicant_sub')}}</p>
        <div class="form-group ">
          <label v-if="getError('organisationType')" class="text-danger">{{getError('organisationType')}}</label>
          <radio name="organisationType"
                 inline
                 value="government_agency"
                 v-validate="'required'"
                 :data-vv-as="$t('general.field')"
                 v-model="GrantForm.revisionModel.technical.organisationType"
          >
            {{$t('page_user.profile__government_agency')}}
          </radio>
          <radio name="organisationType" inline value="protected_conserved_area" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__protected_conserved_area')}}
          </radio>
          <radio name="organisationType" inline value="civil_society_ngo" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__civil_society_ngo')}}
          </radio>
          <radio name="organisationType" inline value="local_community_cbo" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__local_community_cbo')}}
          </radio>
          <radio name="organisationType" inline value="small_medium_enterprise_sme" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__small_medium_enterprise_sme')}}
          </radio>
          <radio name="organisationType" inline value="european_member" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__european_member')}}
          </radio>
          <radio name="organisationType" inline value="oecd_member" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__oecd')}}
          </radio>
          <radio name="organisationType" inline value="regional_org" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__regional_org')}}
          </radio>
          <radio name="organisationType" inline value="international_org" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__international_org')}}
          </radio>
          <radio name="organisationType" inline value="other" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__other')}}
          </radio>
        </div>
        <base-input>
            <textarea
              class="form-control disable-text"
              :placeholder="$t('page_user.profile__other_specify')"
              v-model="GrantForm.revisionModel.technical.organisationTypeOther"
            >
            </textarea>
        </base-input>
        <p class="mt-2 mb-4">{{$t('page_user.profile__organisation_type_note')}}</p>

        <label>{{$t('medium_grant.technical__2_org_history_mission')}}</label>
        <base-input>
            <textarea
              class="form-control disable-text"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.technical.orgHistoryMission"
            >
            </textarea>
        </base-input>
        <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionCnOgFullfilmentEligibility" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionCnOgFullfilmentEligibility" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionCnOgFullfilmentEligibility"  @file="fileAdded"></upload-file>
<div class="mt-4"></div>
    <!-- documents-->
    <div>
      <h3 class="card-title">Due diligence questionnaire and supporting documents</h3>
          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_due_diligence_questionnaire')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionCnDueDiligence" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionCnDueDiligence" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionCnDueDiligence"  @file="fileAdded"></upload-file>

            </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_lead_applicant_declaration_duly_signed')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionCnLeadApplicantDeclaration" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionCnLeadApplicantDeclaration" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionCnLeadApplicantDeclaration"  @file="fileAdded"></upload-file>
          </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_testifying_financial_capacity_applicant')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionCnTestifyingFinancialCapacity" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionCnTestifyingFinancialCapacity" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionCnTestifyingFinancialCapacity"  @file="fileAdded"></upload-file>
          </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_mandate_coapplicant_duly_signed')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionCnMandateCoapplicantDulySigned" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionCnMandateCoapplicantDulySigned" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionCnMandateCoapplicantDulySigned"  @file="fileAdded"></upload-file>
          </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_lead_applicant_due_diligence_and_financial_capacity_questionnaire')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionCnLeadApplicantDueDiligenceAndFinancialCapacityQuestionnaire" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionCnLeadApplicantDueDiligenceAndFinancialCapacityQuestionnaire" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionCnLeadApplicantDueDiligenceAndFinancialCapacityQuestionnaire"  @file="fileAdded"></upload-file>
          </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_coapplicant_due_diligence_and_financial_capacity_questionnaire')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionCnCoapplicantDueDiligenceAndFinancialCapacityQuestionnaire" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionCnCoapplicantDueDiligenceAndFinancialCapacityQuestionnaire" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionCnCoapplicantDueDiligenceAndFinancialCapacityQuestionnaire"  @file="fileAdded"></upload-file>
          </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_status_organisation')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionCnStatusOrganisation" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionCnStatusOrganisation" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionCnStatusOrganisation"  @file="fileAdded"></upload-file>
          </div>
          </div>

          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_lead_applicant_financial_identification_form')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionCnLeadApplicantFinancialIdentification" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionCnLeadApplicantFinancialIdentification" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionCnLeadApplicantFinancialIdentification"  @file="fileAdded"></upload-file>
          </div>

          </div>
          
          <div class="border-bottom border-light">
            <div class="inline my-2">
          <p class="medium">{{$t('medium_grant_cn.document_upload_cv_project_leader')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionCnCvProjectLeader" :allowed-file-type="'pdf'" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionCnCvProjectLeader" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionCnCvProjectLeader"></upload-file>
          </div>
          </div>
        

    <!--alan add other documents-->
        <table class="mt-5 mb-2" width="100%">
          <thead>
            <th>Name</th>
            <th>Upload</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in GrantForm.revisionModel.technical.otherSupportingDocuments" :key="'result_'+index">
              <td>
                <textarea
                  class="form-control"
                  v-model="item.result"
                >
                </textarea>
              </td>
              <td>
                <upload-file
                  v-if="GrantForm.initialized"
                  v-model="GrantForm.files.technical['otherSupportingDocuments' + (index+1)]"
                  class="upload-file"
                  :file-data="GrantForm.files.technical['otherSupportingDocuments' + (index+1)]"
                  :is-editable="GrantForm.isRevisionEditable"
                  :size-limit="GrantForm.fileSizeLimit"
                  :section="'technical.otherSupportingDocuments' + (index + 1)"
                  >
                </upload-file>
              </td>
            </tr>
          </tbody>
        </table>

        <base-button
          type="primary"
          @click.native="addOtherDocument"
          class="ml-2 "
          >
          <i class="tim-icons icon-simple-add mr-2"></i> {{$t('small_technical_grants.logical_framework__add_row_button_title')}}
        </base-button>
        <span class="ml-3">{{$t('small_technical_grants.logical_framework__add_row_button_info')}}</span>
    </div>
    <!-- new-->
      </div>
    </div>
    <h4 class="card-title">{{$t('medium_grant.technical__2_organisational_info_co')}}</h4>
    <div class="row">
      <div class="col-lg-4">
        <label class="col-form-label">{{$t('medium_grant.technical__2_does_include_co')}}</label>
        <div class="form-group ">
          <div class="form-check form-check-radio form-check-inline">
            <radio name="technical.doesIncludeCo"
                   inline value="true"
                   v-validate="'required'"
                   :data-vv-as="$t('general.field')"
                   v-model="GrantForm.revisionModel.technical.doesIncludeCo"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="technical.doesIncludeCo" inline value="false" v-model="GrantForm.revisionModel.technical.doesIncludeCo">
              {{$t('medium_grant.general__no')}}
            </radio>
          </div>
          <div>
            <label v-if="getError('technical.doesIncludeCo')" class="text-danger">{{getError('technical.doesIncludeCo')}}</label>
          </div>
        </div>

        <label class="mt-2 mb-4">{{$t('medium_grant.technical__2_does_include_co_if_yes')}}</label>

        <h4 class="card-title">{{$t('medium_grant.technical__2_organisational_info_co1')}}</h4>
        <div class="form-group ">
          <label for="regionSelect">{{$t('medium_grant.technical__2_org_name_co_app')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.coApplicantOrgName"
            v-model="GrantForm.revisionModel.technical.coApplicantOrgName"
            :label="$t('medium_grant.technical__2_org_name_co_app')"
            :placeholder="$t('medium_grant.technical__2_org_name_co_app')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="regionSelect">Short description of the organization</label>
          <textarea
            class="form-control disable-text"
            name="technical.coShortDescOrg"
            v-model="GrantForm.revisionModel.technical.coShortDescOrg"
            :label="$t('medium_grant.technical__2_short_desc_of_org')"
            :placeholder="$t('medium_grant.technical__2_short_desc_of_org')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="regionSelect">{{$t('medium_grant.technical__2_role_in_project')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.roleInProject"
            v-model="GrantForm.revisionModel.technical.roleInProject"
            :label="$t('medium_grant.technical__2_role_in_project')"
            :placeholder="$t('medium_grant.technical__2_role_in_project')"
          >
          </textarea>
        </div>
        <div class="form-group ">
          <label for="regionSelect">{{$t('medium_grant.technical__2_amount_of_total_budget')}}</label>
          <textarea
            class="form-control disable-text"
            name="technical.amountOfTotalBudget"
            v-model="GrantForm.revisionModel.technical.amountOfTotalBudget"
            :label="$t('medium_grant.technical__2_amount_of_total_budget')"
            :placeholder="$t('medium_grant.technical__2_amount_of_total_budget')"
          >
          </textarea>
        </div>
        <!--check if IUCN member -->
        <div class="form-group ">
        <p class="small">Is an IUCN member?<i class="hover-instruction"></i></p>
        <div class="form-check form-check-radio form-check-inline">
          <radio name="coIucnMember" inline value="true" v-model="GrantForm.revisionModel.technical.coIucnMember">
            {{$t('medium_grant.general__yes')}}
          </radio>
          <radio name="coIucnMember" inline value="false" v-model="GrantForm.revisionModel.technical.coIucnMember">
            {{$t('medium_grant.general__no')}}
          </radio>
        </div>
        </div>

        <div v-if="orgCoApplicants" v-for="(orgCoApplicant, index) in orgCoApplicants" :key="index">
          <h4 class="card-title">
            {{$t('medium_grant.technical__2_organisational_info_co_only') + ' ' + (index+2)}}

            <base-button class="ml-2" @click="orgCoApplicants.splice(index, 1)" size="sm" icon type="danger">
              <i class="fas fa-times"></i>
            </base-button>
          </h4>
          <div class="form-group ">
          <textarea
            class="form-control disable-text"
            name="technical.coApplicantOrgName"
            v-model="orgCoApplicant.orgName"
            :label="$t('medium_grant.technical__2_org_name_co_app')"
            :placeholder="$t('medium_grant.technical__2_org_name_co_app')"
          >
          </textarea>
          </div>
          <div class="form-group ">
          <textarea
            class="form-control disable-text"
            name="technical.coShortDescOrg"
            v-model="orgCoApplicant.shortDesc"
            :label="$t('medium_grant.technical__2_short_desc_of_org')"
            :placeholder="$t('medium_grant.technical__2_short_desc_of_org')"
          >
          </textarea>
          </div>
          <div class="form-group ">
          <textarea
            class="form-control disable-text"
            name="technical.roleInProject"
            v-model="orgCoApplicant.role"
            :label="$t('medium_grant.technical__2_role_in_project')"
            :placeholder="$t('medium_grant.technical__2_role_in_project')"
          >
          </textarea>
          </div>
          <div class="form-group ">
          <textarea
            class="form-control disable-text"
            name="technical.amountOfTotalBudget"
            v-model="orgCoApplicant.budget"
            :label="$t('medium_grant.technical__2_amount_of_total_budget')"
            :placeholder="$t('medium_grant.technical__2_amount_of_total_budget')"
          >
          </textarea>
          </div>
          <div class="form-group ">
          <p class="small">Is an IUCN member?<i class="hover-instruction"></i></p>
          <div class="form-check form-check-radio form-check-inline">
            <radio name="coIucnMember" inline value="true" v-model="GrantForm.revisionModel.technical.coIucnMember">
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="coIucnMember" inline value="false" v-model="GrantForm.revisionModel.technical.coIucnMember">
              {{$t('medium_grant.general__no')}}
            </radio>
        </div>
        </div>
        </div>
        <base-button @click="addOrgCoApplicant" type="primary" class="btn-simple" size="sm">
          + {{$t('medium_grant.technical__2_organisational_info_co_add')}}
        </base-button>

      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";
  import {BaseCheckbox, BaseRadio} from 'src/components/index';
  import {EventBus} from '@/event-bus.js';

  export default {
    data() {
      return {
        GrantForm,
        orgCoApplicants: [],
        showText1: false,
        showText2: true
      }
    },
    components: {
      BaseCheckbox,
      BaseRadio
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      addOrgCoApplicant() {
        this.orgCoApplicants.push({
          orgName: '',
          shortDesc: '',
          role: '',
          budget: ''
        })
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      fileAdded(file) {
                //EventBus.$emit('wizard-save-progress');
      },
      addOtherDocument()
      {
        if (!GrantForm.revisionModel.technical.otherSupportingDocuments)
        {
          GrantForm.revisionModel.technical.otherSupportingDocuments = [];
        }

        GrantForm.revisionModel.technical.otherSupportingDocuments.push({});
        this.$forceUpdate();
      },
    },
    mounted() {
      if (GrantForm.revisionModel.technical.orgCoApplicants) {
        this.orgCoApplicants = GrantForm.revisionModel.technical.orgCoApplicants;
      }
    },
    watch: {
      orgCoApplicants(value) {
        GrantForm.revisionModel.technical.orgCoApplicants = value;
      },
    },
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }

  .inline{
    display: flex;
  justify-content: space-between;
  }

  .inline p{
width: 70%;
  }
  /*.disable-tag,.disable-text {
    pointer-events: none;
  }*/
</style>
